import { clsx } from 'clsx';
import classes from './ActionList.module.css.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

/**
 * Visually separates `Item`s or `Group`s in an `ActionList`.
 */
const Divider = ({
  sx,
  className
}) => {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    className: clsx(className, classes.Divider),
    as: "li",
    "aria-hidden": "true",
    sx: sx,
    "data-component": "ActionList.Divider"
  });
};
Divider.displayName = "Divider";

export { Divider };
